import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';

export interface Props {
  name: string;
  imgSrc: string;
  price: string;
  currency: string;
  unit: string;
  url: string;
  onClick: any;
  searchTerm: string;
}

function ProductSearchItem({
  name,
  imgSrc,
  url,
  price,
  currency,
  unit,
  searchTerm,
  onClick,
}: Props) {
  const invalidChars = /[°"§%()\[\]{}=\\?´`'#<>|,;.:+_-]+/g;
  const parts = name.split(
    new RegExp(`(${searchTerm.replace(invalidChars, '')})`, 'gi'),
  );

  return (
    <Wrapper>
      <ImageNameWrapper onClick={onClick} to={url}>
        <Image alt={`Obrázok ku produktu ${name}`} src={imgSrc} />
        <Name>
          {parts &&
            parts.map((part, i) =>
              part.toLowerCase() === searchTerm.toLowerCase() ? (
                <HighlightedText key={i}>{part}</HighlightedText>
              ) : (
                part
              ),
            )}
        </Name>
      </ImageNameWrapper>
      {price && +price > 0 ? <Price>{`${price} ${currency}`}</Price> : null}
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  width: 100%;
  margin-bottom: ${rem(16)};
  justify-content: space-between;

  &:last-child {
    margin-bottom: 0;
  }
`;

const ImageNameWrapper = styled(Link)`
  display: flex;
  flex-flow: row;
  align-items: center;
  width: 65%;
  margin-right: ${rem(32)};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-decoration: none;

  ${({ theme }) => theme.mediab.l1150`
    margin-right: ${rem(8)};
  `}
`;

const Image = styled.img`
  width: ${rem(32)};
  height: ${rem(32)};
  min-width: ${rem(32)};
  margin-right: ${rem(16)};
`;

const Name = styled(TextP)`
  font-size: ${rem(14)};
  font-weight: 400;
  text-decoration: none;
  line-height: 1.2857142857;
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.font.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    text-decoration: underline;
  }

  ${({ theme }) => theme.mediab.s450`
    max-width: ${rem(130)};
  `}
`;

const Price = styled(TextP)`
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: 1.2857142857;
  color: ${({ theme }) => theme.colors.black};
  white-space: nowrap;
  font-family: ${({ theme }) => theme.font.primary};
`;

const HighlightedText = styled.span`
  background-color: ${({ theme }) => theme.colors.highlight};
`;

export { ProductSearchItem };
